export default {
    formatBytes: fileSize => {
        if (0 == fileSize) return '0 Bytes';
        var c = 1024,
            d = 0 || 2,
            e = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            f = Math.floor(Math.log(fileSize) / Math.log(c));

        return parseFloat((fileSize / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
    },
    fileSize: fileSize => {
        if (fileSize < 1000) {
            return `${fileSize} B`;
        }
        if (Math.round(fileSize / 1000) < 1000) {
            return Math.round(fileSize / 1000) + ' Kb';
        }
        if (
            Math.round(fileSize / 1000) > 1000 &&
            Math.round(fileSize / 1000) < 1000000
        ) {
            return Math.round(fileSize / 1000000) + ' Mb';
        }
    },
    readAsArrayBuffer: file => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onerror = () => {
                reader.abort();
                reject(new Error('Failed to read file' + file.name));
            };

            reader.onloadend = e => {
                if (e.target.readyState === FileReader.DONE) {
                    resolve(reader.result);
                }
            };

            reader.readAsArrayBuffer(file);
        });
    },

    readAsBinString: file => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onerror = () => {
                reader.abort();
                reject(new Error('Failed to read file' + file.name));
            };

            reader.onloadend = evt => {
                if (evt.target.readyState === FileReader.DONE) {
                    resolve(reader.result);
                }
            };

            reader.readAsBinaryString(file);
        });
    },
    isValidFileName: (function(){
        // eslint-disable-next-line no-useless-escape
        var rg1=/^[^\\/:\*\?"<>,\|]+$/; // forbidden characters \ / : * ? " < > |
        var rg2=/^\./; // cannot start with dot (.)
        var rg3=/^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i; // forbidden file names
        return function isValid(file){
            if(!rg1.test(file.name)&&!rg2.test(file.name)&&!rg3.test(file.name)){
                return {
                    code: "invalid-filename",
                    message: `invalid file name`
                };
            } 
            else 
                return null;
        };
    })()
};
